import { render, staticRenderFns } from "./LoginMain.vue?vue&type=template&id=324feecc&scoped=true"
import script from "./LoginMain.vue?vue&type=script&lang=js"
export * from "./LoginMain.vue?vue&type=script&lang=js"
import style0 from "./LoginMain.vue?vue&type=style&index=0&id=324feecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324feecc",
  null
  
)

export default component.exports